(() => {
  const dialog = document.querySelector('[data-video-modal]');
  const frame = dialog?.querySelector('[data-video-frame]');
  const sources = document.querySelector('[data-video-sources]');
  if (!dialog || !frame || !sources) return;

  document.querySelectorAll('[data-video-open]').forEach((button) => {
    button.addEventListener('click', () => {
      const template = sources.querySelector(`[data-video-source-index="${button.dataset.videoIndex}"]`);
      if (!template) return;
      frame.innerHTML = '';
      frame.appendChild(template.content.cloneNode(true));
      dialog.showModal();
      frame.querySelector('video')?.play();
    });
  });

  const closeModal = () => {
    dialog.close();
    frame.querySelector('video')?.pause();
    frame.innerHTML = '';
  };

  dialog.querySelector('[data-video-close]')?.addEventListener('click', closeModal);
  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) closeModal();
  });
  dialog.addEventListener('close', () => { frame.innerHTML = ''; });
})();
